import { useCallback, useEffect, useState } from "react";

import { useRoleGuardHook } from "hooks";
import { useReportsActions } from "store";

import { RoleName } from "../../constants";

interface Settings {
  listenReports: () => void;
}

export function useApiCalls({ listenReports }: Settings): boolean {
  const { getMetaAction } = useReportsActions();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const getMetaWithRole = useRoleGuardHook(getMetaAction, [RoleName.Admin, RoleName.Analyst, RoleName.Investor]);

  const callsWrapper = useCallback(async () => {
    try {
      await Promise.allSettled([getMetaWithRole?.(true)]);
    } finally {
      setIsLoading(false);
      listenReports();
    }
  }, [getMetaAction]);

  useEffect(() => {
    callsWrapper();
  }, []);

  return isLoading;
}
